<template>
	<div id="eol-available">
		<div id="center-wrapper">
			<img class="logo" src="./ic-logo.png" />
			<div class="head-text">서비스 이용 불가 안내</div>
			<div class="description-text">
				로그인 하신 계정은 2023년 9월 16일부로 종료된 이전 버전의
				랩매니저에서 사용하시던 계정으로 확인됩니다. 종료된 서비스의
				데이터를 이관하여 계속해서 사용을 원하신다면 아래 카카오톡
				채널로 문의 해 주세요.
			</div>
		</div>

		<div class="Btn__wrap">
			<button class="Btn__disabled" @click="clickShareLink">
				<img src="./ic-kakao.png" />
				카카오톡으로 문의하기
			</button>
		</div>
	</div>
</template>

<script>
export default {
	methods: {
		clickShareLink() {
			// eslint-disable-next-line no-undef
			location.href = 'http://pf.kakao.com/_bxfQxmj/chat'
		},
	},
}
</script>

<style lang="scss" scoped>
#eol-available {
	position: relative;
	width: 100vw;
	height: calc(var(--vh, 1vh) * 100);

	#center-wrapper {
		position: absolute;
		display: flex;
		align-items: center;
		justify-content: center;
		flex-direction: column;
		top: 45%;
		left: 50%;
		width: 100%;
		padding: 30px;
		transform: translate(-50%, -50%);
		.logo {
			border-radius: 20px;
			width: 80px;
			height: 80px;
			margin-bottom: 20px;
		}

		.head-text {
			font-size: 2rem;
			text-align: center;
			font-weight: bold;
		}

		.description-text {
			margin-top: 2vh;
			font-size: 0.9em;
			text-align: center;
			word-break: keep-all;
			// font-weight: 300;
		}

		.description-image-wrapper {
			border-radius: 20px;
			background-color: #f5f5f5;
			padding: 20px 20px 10px;
			margin-top: 40px;
			.description-text {
				margin-top: 0;
				font-size: 0.8rem;
			}
			img {
				margin-top: 20px;
				width: 100%;
			}
		}
	}
}

.Btn__wrap {
	text-align: center;
	width: 100%;
	padding: 16px 20px;

	position: absolute;
	left: 0px;
	bottom: 10px;

	button {
		background-color: #fee500;
		width: 100%;
		height: 48px;
		font-size: 1.125rem;
		color: black;
		display: flex;
		align-items: center;
		justify-content: center;
		gap: 8px;
	}
}
</style>
